const handleEdit = (orgCard, editedItems, allCards) => {
  let card = { ...orgCard };
  for (let item in editedItems) {
    card[item] = editedItems[item];
  }
  let cardLevel;
  let cardGroup = card["learningLevel"];
  if (cardGroup == 1) cardLevel = "one";
  else if (cardGroup == 2) cardLevel = "two";
  else if (cardGroup == 3) cardLevel = "three";
  else if (cardGroup == 4) cardLevel = "four";
  else if (cardGroup == 5) cardLevel = "five";
  else if (cardGroup == 6) cardLevel = "six";
  else if (cardGroup == 7) cardLevel = "seven";
  else if (cardGroup == 8) cardLevel = "eight";
  else if (cardGroup == 9) cardLevel = "nine";
  else if (cardGroup == 10) cardLevel = "ten";

  let newAllcards = { ...allCards };
  let index;
  newAllcards[cardLevel].forEach((el, idx) => {
    if (orgCard["_id"] == el["_id"]) index = idx;
  });
  if (index > -1) {
    newAllcards[cardLevel][index] = card;
  }
  return newAllcards;
};

export { handleEdit };
